const Types = {
    FORGOT_PASSWORD_CHECK: "FORGOT_PASSWORD_CHECK",
    FORGOT_PASSWORD_ERROR: "FORGOT_PASSWORD_ERROR",
    FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
};

export default Types;
